// extracted by mini-css-extract-plugin
module.exports = {"reviewStar":"ReviewsHeader_reviewStar__82Enu","reviewStarMobile":"ReviewsHeader_reviewStarMobile__OCHaK","textColor":"ReviewsHeader_textColor__3BHRQ"};